
ADILF.define('streamhub-sdk/content/views/instagram-content-view',['require','exports','module','inherits','streamhub-sdk/content/views/livefyre-content-view','streamhub-sdk/ui/button','streamhub-sdk/content/views/mixins/livefyre-content-view-mixin','streamhub-sdk/content/views/mixins/instagram-content-view-mixin'],function (require, exports, module) {var inherits = require('inherits');
var LivefyreContentView = require('streamhub-sdk/content/views/livefyre-content-view');
var Button = require('streamhub-sdk/ui/button');
var asLivefyreContentView = require('streamhub-sdk/content/views/mixins/livefyre-content-view-mixin');
var asInstagramContentView = require('streamhub-sdk/content/views/mixins/instagram-content-view-mixin');

'use strict';

/**
 * A view for rendering instagram content into an element.
 * @param opts {Object} The set of options to configure this view with (See LivefyreContentView).
 * @exports streamhub-sdk/content/views/instagram-content-view
 * @constructor
 */
var InstagramContentView = function (opts) {
    LivefyreContentView.call(this, opts);
    asInstagramContentView(this, opts);
};
inherits(InstagramContentView, LivefyreContentView);

module.exports = InstagramContentView;

});
